var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2535",
    "data-name": "Rectangle 2535",
    width: 12.291,
    height: 12.291,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5278",
    "data-name": "Group 5278",
    transform: "translate(-751 -405)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_760",
    "data-name": "Ellipse 760",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(751 405)",
    fill: "#ffa701"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LOADING",
    transform: "translate(753.355 407.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5277",
    "data-name": "Group 5277",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5405",
    "data-name": "Path 5405",
    d: "M7.273,1.484l.341.083A4.885,4.885,0,0,1,10.022,3.31l.2.314a3.127,3.127,0,0,1,.357.7l.133.324.089.358a3.131,3.131,0,0,1,.123.777l.026.35a4.808,4.808,0,0,1-5.552,4.758,4.745,4.745,0,0,1-1.907-.751l-.169-.1a4.9,4.9,0,0,1-1.752-2.4,4.7,4.7,0,0,1-.2-1.995l.02-.243.151-.635-.159-.051L.258,4.35a6.169,6.169,0,0,0,.4,4.595c.094.151.173.281.236.386a3.977,3.977,0,0,0,.591.814c.081.093.18.208.307.356.136.115.251.214.344.294a3.965,3.965,0,0,0,.814.591l.4.244c.165.067.305.126.419.174a3.99,3.99,0,0,0,.957.311l.457.108c.177.013.329.025.451.036a3.964,3.964,0,0,0,1.006,0l.469-.038c.172-.043.32-.078.44-.106A3.989,3.989,0,0,0,8.5,11.8l.434-.181c.151-.094.281-.173.386-.236a3.97,3.97,0,0,0,.814-.591l.356-.306.626-.735a6.234,6.234,0,0,0,1.17-3.619A6.141,6.141,0,0,0,6.247,0V1.343l.249.019a3.126,3.126,0,0,1,.777.123",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationIconWarning);
export default __webpack_public_path__ + "static/media/validation_icon_warning.d927cb0a80f5338b0650afc484679639.svg";
export { ForwardRef as ReactComponent };